"use client";

import React from "react";
import "./IndustriesSection.scss";

import { motion } from "framer-motion";
import fintech from "@/assets/images/services/web-app/fintech.webp";
import industry from "@/assets/images/services/web-app/industry.webp";
import discuss from "@/assets/images/services/web-app/discuss.webp";

import Image from "next/image";

const IndustriesSection = ({ data }) => {
  const { title, description, items } = data;

  const imageMap = {
    fintech,
    industry,
    discuss,
  };
  return (
    <section className="industries-section">
      <div className="container">
        <div className="industries-grid">
          <div className="industries-content">
            <h2>{title}</h2>

            <p>{description}</p>
          </div>

          {items.map((item, index) => (
            <div
              key={item.id || index}
              className={`industry-card ${item.image ? "image-card" : ""}`}
            >
              {item.image ? (
                <Image
                  src={imageMap[item.image]}
                  alt={item.title || "industry"}
                />
              ) : (
                <>
                  <div className="icon-box">
                    <Image
                      src={item.icon}
                      alt={item.title}
                      width={28}
                      height={28}
                    />
                  </div>

                  <h4>{item.title}</h4>

                  <p>{item.desc}</p>
                </>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection;
